'use client';

import type React from 'react';
import styled from 'styled-components';
import { getBasePath } from '../../utils/basePath';
import { StyledIconP, StyledSocialIcon } from '../styled';

const LinkAnchor = styled.a`
  text-decoration: none;
  display: inline-block;
`;

export type MediaButtonsProps = {
  links?: Array<Record<string, string>>;
  isInViewport: boolean;
  bgColor: string;
  spacing?: string;
  size?: string;
};

/**
 * Social & streaming service link badges.
 */
export const MediaButtons: React.FC<MediaButtonsProps> = ({
  links,
  isInViewport,
  bgColor,
  spacing,
}) => {
  const basePath = getBasePath();

  if (!links || links.length === 0) return null;

  return (
    <>
      {links.map((linkObj, index) => {
        const platform = Object.keys(linkObj)[0];
        const url = linkObj[platform];
        if (!url) return null;

        return (
          <LinkAnchor
            key={`${platform}-${url}-${index}`}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Listen on ${platform}`}
          >
            <StyledSocialIcon
              className={isInViewport ? 'scaleIn' : 'scaleOut'}
              style={{
                backgroundColor: bgColor,
                margin: spacing ?? '4px',
              }}
            >
              <img alt={platform} src={`${basePath}/assets/icons/${platform}.png`} />
              <StyledIconP>{platform}</StyledIconP>
            </StyledSocialIcon>
          </LinkAnchor>
        );
      })}
    </>
  );
};

export default MediaButtons;
